import { render } from "./knowledgebase-view.vue?vue&type=template&id=2f0d876d"
import script from "./knowledgebase-view.vue?vue&type=script&lang=js"
export * from "./knowledgebase-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__